module.exports = __webpack_public_path__ + "img/icon-edit-acc.02c3d4c5.svg";